/**
 * Calculates the age in years based on the provided birthdate.
 * Uses the last day of the birth month for calculation.
 *
 * @param birthDate - The date of birth to calculate age from. OK to pass just
 * birthMonth and birthYear as a string in the format "YYYY-MM". Day will
 * always be treated as the last day of the month.
 * @returns The age in years
 */
export function getAge(birthDate: Date | string | null | undefined): number {
    if (!birthDate) {
        return 0;
    }

    // birthday: Actual birth day way back when the user was born.
    let bday: Date = birthDate as Date;
    if (typeof birthDate === "string") {
        if (birthDate.match("T")) {
            // If the date string contains a time, parse it as a full date.
            bday = new Date(birthDate);
        } else {
            // Otherwise, assume it's a year and month string.
            bday = new Date(birthDate + "T00:00:00");
        }
        bday.setDate(1);
    }

    // bday end of month: Get the last day of the birth month by
    // incrementing the month by 1 and then going back a day (setting it to '0').
    const bdayEom = new Date(
        bday.getFullYear(),
        bday.getMonth() + 1,
        0,
        23,
        59,
        59,
        999,
    );

    // The time to compare bday against
    const now = new Date();

    // current bday: This year's birthday, as of the end of the month
    const currentBday = new Date(bdayEom);
    currentBday.setFullYear(now.getFullYear());

    // Calculate age
    let age = now.getFullYear() - bdayEom.getFullYear();

    // If this years birthday hasn't come yet, subtract 1
    return now <= currentBday ? --age : age;
}
